import React from 'react'
import {IconButton} from '@mui/material'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import styled from 'styled-components'

export interface ListPaginationActionsForSpProps {
    count: number;
    onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
    page: number;
    rowsPerPage: number;
}

const ListPaginationActionsForSp: React.FC<ListPaginationActionsForSpProps> = props => {
    const {count, page, rowsPerPage, onPageChange} = props

    const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        onPageChange(event, 0)
    }

    const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        onPageChange(event, page - 1)
    }

    const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        onPageChange(event, page + 1)
    }

    const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }

    const isFirstPage = page === 0
    const isLastPage = page >= Math.ceil(count / rowsPerPage) - 1
    const from = isFirstPage ? 1 : (page * rowsPerPage) + 1
    const to = isLastPage ? count : (page + 1) * rowsPerPage

    return (
        <ActionsFlexContainer>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={isFirstPage}
                aria-label="first page"
                size="large">
                <FirstPageIcon/>
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={isFirstPage}
                aria-label="previous page"
                size="large">
                <KeyboardArrowLeft/>
            </IconButton>
            <InformationLabelSpan>{from}〜{to} / {count}件</InformationLabelSpan>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={isLastPage}
                aria-label="next page"
                size="large">
                <KeyboardArrowRight/>
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={isLastPage}
                aria-label="last page"
                size="large">
                <LastPageIcon/>
            </IconButton>
        </ActionsFlexContainer>
    );
}

export default ListPaginationActionsForSp

const InformationLabelSpan = styled.span`
  display: flex;
  justify-content: center;
  flex-grow: 1;
`

const ActionsFlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
